import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import { UserV2 } from 'models/settingsV2.model';
import useService from '../../utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../helper';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { showAlert, app } = useContext(AppContext);
	const {
		requestUpdateUser,
		getDepartmentOptions,
		getManagerOptions,
		getDesignationOptions,
		getTeamOptions,
		getRoleNameTempOptions
	} = useService();

	const location = useLocation();
	const data = _get(location, ['state', 'rowData']);
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DEPARTMENT].setRenderProps({ getOptions: getDepartmentOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.MANAGER].setRenderProps({ getOptions: getManagerOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DESIGNATION].setRenderProps({ getOptions: getDesignationOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.TEAM].setRenderProps({ getOptions: getTeamOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.ROLE_NAME_TEMP].setRenderProps({ getOptions: getRoleNameTempOptions });
	const updateUser = async (updatedData: UserV2) => {
		setShowLoader(true);
		try {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { _id, index, id, permissionsInfo, updatedBy, ...restUpdateData } = updatedData;
			const updatedUserData = {
				...restUpdateData,
				userId: _id
			};
			const response = await requestUpdateUser(app.appName, updatedUserData);
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to edit user');
			}
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while editing this user', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('User edited successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (submittedData: UserV2) => {
		updateUser(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useEdit;
